var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResultFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 667.955,
    height: 363.556,
    viewBox: "0 0 667.955 363.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2433",
    "data-name": "Group 2433",
    transform: "translate(-673.987 -321.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2418",
    "data-name": "Group 2418",
    transform: "translate(622.328 288.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M364.071,93.3c-43.671,16.621-182-65.338-171.172,46.612,1.692,16.646,10.686,40.159,3.09,55.7-5.5,11.638-15.593,18.458-25.337,22.983-25.456,12.337-34.934,35.49-28.487,68.535,17.243,89.044,111.112,67.927,160.39,41.525C337.6,309,378.93,305.63,415.219,322.251c28.429,13.534,46.152,41.925,79.518,33.608,29.592-7.079,34.057-40.382,25.417-71.384-4.909-19.18-8.434-27.285,1.3-45.8,8.206-18.387,22.647-32.32,23.759-53.862.243-23.331-8.75-46.843-26.155-55.68-14.241-7.229-27.148-4.311-41.235-8.756-31.335-10.5-51.472-68.534-90.344-48.574-9.692,5.453-15.146,18.022-25.707,21.682",
    transform: "translate(0 3.145)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeWidth: 1,
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2417",
    "data-name": "Group 2417",
    transform: "translate(144.442 60.987)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M326.647,78.174",
    transform: "translate(-120.9 -52.885)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M163.71,159.987",
    transform: "translate(-133.363 -28.253)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M494.4,203.849",
    transform: "translate(-106.554 -13.751)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M308.085,72.674",
    transform: "translate(-123.143 -55.478)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M505.4,184.737",
    transform: "translate(-101.369 -20.07)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M145.148,176.487",
    transform: "translate(-142.113 -22.798)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M450.4,90.549",
    transform: "translate(-127.295 -47.052)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M323.9,60.987",
    transform: "translate(-121.232 -60.987)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M511.31,200.686",
    transform: "translate(-98.581 -14.796)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M143.223,156.549",
    transform: "translate(-143.02 -29.39)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M467.585,101.549",
    transform: "translate(-119.193 -41.867)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M466.21,87.8",
    transform: "translate(-119.841 -48.348)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M187.636,75.561",
    transform: "translate(-122.085 -54.117)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M500.585,265.175",
    transform: "translate(-103.637 4.495)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M143.085,269.987",
    transform: "translate(-143.085 6.763)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M204.136,70.061",
    transform: "translate(-114.307 -56.71)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M501.272,245.925",
    transform: "translate(-103.313 -4.579)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M159.585,279.612",
    transform: "translate(-135.307 11.3)",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2424",
    "data-name": "Group 2424",
    transform: "translate(397.193 185.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M468.2,188.886l-6.434-6.434-6.133,6.133-6.133-6.133-6.434,6.434,6.133,6.133-6.133,6.133,6.434,6.434,6.133-6.133,6.133,6.133,6.434-6.434-6.133-6.133Z",
    transform: "translate(345.166 22.733)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M326.111,166.965l-6.434-6.434-6.133,6.133-6.133-6.133-6.434,6.434,6.133,6.133-6.133,6.133,6.434,6.434,6.133-6.133,6.133,6.133,6.434-6.434-6.133-6.133Z",
    transform: "translate(77.055 13.069)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M534.208,332.378l-6.434-6.434-6.133,6.133-6.133-6.133-6.434,6.434,6.133,6.133-6.133,6.133,6.434,6.434,6.133-6.133,6.133,6.133,6.434-6.434-6.133-6.133Z",
    transform: "translate(290.365 103.056)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2419",
    "data-name": "Group 2419",
    transform: "translate(276.794 210.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M258.252,209.336a9.39,9.39,0,1,1,9.391-9.389A9.4,9.4,0,0,1,258.252,209.336Zm0-14.894a5.5,5.5,0,1,0,5.505,5.505A5.509,5.509,0,0,0,258.252,194.442Z",
    transform: "translate(-248.863 -190.557)",
    fill: "#f2f5f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2420",
    "data-name": "Group 2420",
    transform: "translate(698.712 135.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M398.661,165.444a9.389,9.389,0,1,1,9.391-9.389A9.4,9.4,0,0,1,398.661,165.444Zm0-14.892a5.5,5.5,0,1,0,5.505,5.5A5.51,5.51,0,0,0,398.661,150.552Z",
    transform: "translate(-389.272 -146.667)",
    fill: "#f2f5f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2421",
    "data-name": "Group 2421",
    transform: "translate(925.969 237.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M534.179,233.157a9.39,9.39,0,1,1,9.391-9.389A9.4,9.4,0,0,1,534.179,233.157Zm0-14.894a5.5,5.5,0,1,0,5.505,5.505A5.51,5.51,0,0,0,534.179,218.263Z",
    transform: "translate(-524.79 -214.378)",
    fill: "#f2f5f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2422",
    "data-name": "Group 2422",
    transform: "translate(830.21 334.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M472.531,312.931a9.39,9.39,0,1,1,9.391-9.391A9.4,9.4,0,0,1,472.531,312.931Zm0-14.894a5.5,5.5,0,1,0,5.505,5.5A5.51,5.51,0,0,0,472.531,298.037Z",
    transform: "translate(-463.142 -294.152)",
    fill: "#f2f5f8"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 8.783,
    cy: 8.783,
    r: 8.783,
    transform: "translate(395.226 370.716)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M552.022,291.511a8.783,8.783,0,1,1-8.783-8.783A8.782,8.782,0,0,1,552.022,291.511Z",
    transform: "translate(314.292 93.172)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M462.583,233.612a8.784,8.784,0,1,1-8.785-8.783A8.784,8.784,0,0,1,462.583,233.612Z",
    transform: "translate(360.982 60.9)",
    fill: "#f2f5f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 13.208,
    cy: 13.208,
    r: 13.208,
    transform: "translate(689.037 472.807)",
    fill: "#f2f5f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2432",
    "data-name": "Group 2432",
    transform: "translate(-15 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2416",
    "data-name": "Group 2416",
    transform: "translate(900 441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M705.381,312.83l.429-.394a1.572,1.572,0,0,0,.1-2.224L697.2,300.7a70.848,70.848,0,1,0-16.552,15.152l8.709,9.515a1.574,1.574,0,0,0,2.224.1l.429-.394L756.568,395.6H781.13Z",
    transform: "translate(-544.964 -173.714)",
    fill: "#212121",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2415",
    "data-name": "Group 2415",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M648.926,292.639l12.695,12.693a1.66,1.66,0,0,0,2.348,0l14.394-14.394a1.66,1.66,0,0,0,0-2.347L665.668,275.9Z",
    transform: "translate(-533.378 -160.349)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M667.57,277.641l1.618,1.618-13.6,19.88-5.982-5.982Z",
    transform: "translate(-533.278 -160.09)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M662.407,302.9l13.518-13.518.924.924-10.568,16.469Z",
    transform: "translate(-531.379 -158.35)",
    fill: "#212121",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M623.08,175.273a74.778,74.778,0,1,0,74.777,74.777A74.778,74.778,0,0,0,623.08,175.273Zm0,134.1A59.324,59.324,0,1,1,682.4,250.05,59.324,59.324,0,0,1,623.08,309.374Z",
    transform: "translate(-548.302 -175.273)",
    fill: "#ce2e6c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 59.324,
    cy: 59.324,
    r: 59.324,
    transform: "translate(15.454 15.454)",
    fill: "#ececec",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M580.688,207.659c-8.581,8.58-13.737,17.335-11.519,19.555s10.974-2.937,19.556-11.518,13.737-17.336,11.518-19.556S589.268,199.078,580.688,207.659Z",
    transform: "translate(-545.283 -172.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M776.1,389.559,670.936,284.384l-13.523,13.523L762.589,403.075a9.557,9.557,0,0,0,14.05-.581h0A9.557,9.557,0,0,0,776.1,389.559Z",
    transform: "translate(-532.119 -159.09)",
    fill: "#ce2e6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431",
    transform: "translate(935.935 498.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2427",
    "data-name": "Group 2427",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2425",
    "data-name": "Group 2425"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x1: 14.292,
    y2: 14.29,
    strokeWidth: 3.3,
    stroke: "#425973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x1: 14.291,
    y1: 14.291,
    transform: "translate(0.001 0.001)",
    fill: "none",
    stroke: "#425973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2426",
    "data-name": "Group 2426",
    transform: "translate(64.42)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x1: 14.292,
    y2: 14.29,
    strokeWidth: 3.3,
    stroke: "#425973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x1: 14.29,
    y1: 14.291,
    transform: "translate(0.002 0.001)",
    fill: "none",
    stroke: "#425973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2429",
    "data-name": "Group 2429",
    transform: "translate(10.235 33.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428",
    transform: "translate(26.341 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M318.423,445.659v14.1a5.053,5.053,0,0,1-5.054,5.053h-2.725a5.052,5.052,0,0,1-5.053-5.053v-14.1",
    transform: "translate(-305.592 -445.659)",
    fill: "#dd9ab2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M311.179,446.3v16.421",
    transform: "translate(-304.763 -445.564)",
    fill: "none",
    stroke: "#d6819f",
    strokeMiterlimit: 10,
    strokeWidth: 3.86
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x2: 49.055,
    strokeWidth: 2.75,
    stroke: "#425973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2430",
    "data-name": "Group 2430",
    transform: "translate(0.812 23.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M238.579,438.326",
    transform: "translate(-238.579 -438.326)",
    fill: "none",
    stroke: "#e9c2d0",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M337.579,438.326",
    transform: "translate(-260.491 -438.326)",
    fill: "none",
    stroke: "#e9c2d0",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFound);
export default __webpack_public_path__ + "static/media/no-result-found.36dd665fd1e1c5fd5d9dde81e5a5db77.svg";
export { ForwardRef as ReactComponent };